import { Box, Button, Stack, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { Context } from "../../App";

export default function UnScannBillet({billet, close}) {
    const {setIsConnected } =useContext(Context)
    const [load, setLoad] = useState(false)

    async function handleUnScan() {
        const query = new URLSearchParams({num: billet.num}).toString();
        setLoad(true);

        const response = await fetch(process.env.REACT_APP_API_URL.concat(`/billet?${query}`), {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },body: JSON.stringify({statut:'valide'})
        });

        const token = response.headers.get('x-auth-token');
        if (response.status === 401) {
            sessionStorage.clear();
            setIsConnected(false);
        } else {
            if (token && token !== sessionStorage.getItem('token') && token !== '') {
                sessionStorage.setItem('token', token);
            }

            if (response.status === 200) {
                close();
            } else {
                const text = await response.text();
                console.error(text);
            }
        }
    }

    return(
        <Box>
            <Typography variant="subtitle1" align="center">Ce billet a déjà été scanné. Souhaitez-vous annuler le scan ?</Typography>
            <Stack direction="row" spacing={2} marginTop={2} justifyContent="center">
                <Button variant="outlined" color="focus" onClick={close}>Non</Button>
                <Button variant="contained" onClick={handleUnScan}>Oui</Button>
            </Stack>
        </Box>
    )
}